import React from 'react';

import NumberHelper from 'util/number_helper';
import Export from 'components/Explorer/Export';
import SaveSearch from 'components/Explorer/SaveSearch';
import SummaryBlock from 'components/Explorer/ContentPanel/SummaryBlock';
import helpFor from 'util/help.js';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const Summary = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('mentions/summary', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const loadingFailed = loading === Loading.ERROR;

  const posts = data?.posts ?? null;
  const mentions = data?.mentions ?? null;

  const summarySentence = () => {
    if (loadingFailed) return I18n.t('Explorer.Mentions.Summary.error');
    const postsSentence = I18n.t('Explorer.Mentions.Summary.individual_posts', {
      count: posts,
      formattedCount: NumberHelper.formatNumberWithDelimiter(posts)
    });
    return I18n.htmlSafe('Explorer.Mentions.Summary.result_description', {
      count: mentions,
      formattedCount: NumberHelper.formatNumberWithDelimiter(mentions),
      postsSentence
    });
  };

  return (
    <SummaryBlock hasWarning={mentions === 0}>
      {isLoading ? (
        I18n.t('Explorer.Mentions.Summary.loading')
      ) : (
        <>
          <div>{summarySentence()}</div>
          <Export endpoint="mentions" resultsCount={mentions || 0} help={helpFor('mentions')} />
          <SaveSearch endpoint="mentions" analyticsName="Mentions" />
        </>
      )}
    </SummaryBlock>
  );
};

export default Summary;
